import React from "react"
import { diff_in_days } from "../../../../utils/dates/diff_in_days"

import style from "./index.module.sass"

const MAX_DAYS_TO_BE_NEW = 30

function VenueBadges(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue } = props
  const { first_published_at, promotion, priority } = venue

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const isNew = -diff_in_days(first_published_at) < MAX_DAYS_TO_BE_NEW

  // -------------------------------------

  if (!isNew && !promotion && !(priority > 0)) {
    return <div></div>
  }

  return (
    <div className={style.venueBoxBadges}>
      {isNew && (
        <span className={`${style.badge} ${style.badgeLightOrange}`}>
          {I18n.t("pages.locations.venues.venue_box.new")}
        </span>
      )}
      {promotion && (
        <span className={`${style.badge} ${style.badgePink}`}>
          {I18n.t("pages.locations.venues.venue_box.promotion")}
        </span>
      )}
      {priority > 0 && (
        <span className={`${style.badge} ${style.badgeLightBlue}`}>
          {I18n.t("pages.locations.venues.venue_box.sponsored")}
        </span>
      )}
    </div>
  )
}

export default VenueBadges
